var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a-power",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M9.1 5.4 8 6.2q-.95.65-1.8 1.55-2.95 3.35-2.95 7.75 0 4.8 3.5 8.15 3.4 3.4 8.3 3.4 4.85 0 8.35-3.4 3.4-3.35 3.4-8.15 0-4.4-3-7.75-.7-.8-1.7-1.55l-1.15-.8m-5.9-2.45v12.3"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a-power"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPower);
export default __webpack_public_path__ + "static/media/icon-power.41e469681fa04e039fd3059fdb524293.svg";
export { ForwardRef as ReactComponent };